import { AppError } from './AppError';

/**
 * Base class for business-rule violations raised inside a feature's domain layer.
 * Per architecture rules, concrete domain errors are defined inside
 * `features/<name>/domain/errors`, not here — this is only the shared base type.
 */
export class DomainError extends AppError {
  constructor(code: string, message: string, options?: { cause?: unknown }) {
    super(code, message, options);
    this.name = 'DomainError';
    Object.setPrototypeOf(this, DomainError.prototype);
  }
}
